import certificateImg from "../../assets/images/hd-cce-certificate.png";

const CERT_ITEMS = [
  {
    label: "AFTER EACH LEVEL",
    title: "Level certificate, issued online",
    desc: "Sit the exam whenever you are ready \u2014 no exam windows, no travel. One free retake per level is included.",
  },
  {
    label: "AFTER ALL TEN LEVELS",
    title: "HD-CCE \u2014 Hack Defense Certified Cybersecurity Expert",
    desc: "Awarded on ten passed exams, ten graded projects and the final capstone. A one-year professional programme certificate issued by Hack Defense, verifiable online by any employer.",
  },
  {
    label: "ALONGSIDE IT",
    title: "Ten external certifications you are now ready for",
    desc: "Network+, Linux+, Security+, CEH, OSCP-class practicals, CySA+/BTL1, ISO 27001 LA or CISM, GPYC, an AI security specialisation and AWS Security Specialty / SC-100.",
  },
];

export default function CertificationSection() {
  return (
    <section id="certification" className="max-w-[1200px] mx-auto px-4 py-12 sm:px-6 md:px-10 sm:py-22">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-start">
        <div>
          <div
            className="font-mono text-[12px] text-[#71717a] mb-[18px]"
            style={{ letterSpacing: "0.18em" }}
          >
            08 — EXAMS & CERTIFICATION
          </div>
          <h2
            className="font-bold text-white mb-[18px]"
            style={{
              fontSize: "clamp(30px, 3.7vw, 46px)",
              lineHeight: 1.06,
              letterSpacing: "-0.03em",
            }}
          >
            Ten exams. Ten certificates. One expert.
          </h2>
          <p className="text-[16px] sm:text-[18px] leading-[1.65] text-[#a1a1aa] mb-8">
            Every level ends in an online exam — half scenario questions,
            half a timed practical in the lab range. Pass it and your
            certificate is issued immediately, with a unique ID and a public
            verification link an employer can check.
          </p>
          <div className="grid gap-px bg-[#27272a] border border-[#27272a] rounded-xl overflow-hidden">
            {CERT_ITEMS.map((item, i) => (
              <div key={i} className="bg-black p-6">
                <div
                  className="font-mono text-[11px] text-[#a3e635] mb-2"
                  style={{ letterSpacing: "0.12em" }}
                >
                  {item.label}
                </div>
                <div className="text-[16px] font-semibold mb-1.5">
                  {item.title}
                </div>
                <div className="text-[14px] text-[#a1a1aa] leading-relaxed">
                  {item.desc}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid gap-5">
          <div className="border border-[#27272a] rounded-[14px] overflow-hidden">
            <img
              src={certificateImg}
              alt="Hack Defense Certified Cybersecurity Expert certificate"
              className="w-full h-auto"
            />
          </div>

          <div className="border border-[#a3e635] rounded-[14px] bg-[#09090b] p-5 sm:p-[30px] relative">
            <div className="absolute -top-[11px] left-4 sm:left-[30px] bg-[#a3e635] text-black font-mono text-[10px] px-2.5 py-1 rounded-[4px] font-bold" style={{ letterSpacing: "0.14em" }}>
              FREE WITH THE FULL TRACK
            </div>
            <div className="flex items-baseline gap-3 flex-wrap mb-2.5">
              <div className="text-[17px] sm:text-[21px] font-bold" style={{ letterSpacing: "-0.02em" }}>
                CV Building & Mock Interview
              </div>
              <div className="font-mono text-[14px] text-[#52525b] line-through">
                $49
              </div>
              <div className="font-mono text-[14px] text-[#a3e635]">
                FREE ON COMPLETION
              </div>
            </div>
            <div className="text-[14px] text-[#a1a1aa] leading-[1.65] mb-[18px]">
              Security-specific CV and LinkedIn rewriting, ATS keywords,
              packaging your ten graded projects as a portfolio — plus a
              one-to-one mock technical interview with a practising security
              professional and written feedback afterwards. Complimentary for
              every student who completes all ten levels.
            </div>
            <div className="text-[14px] text-[#d4d4d8] leading-[1.65]">
              Not studying with us? You can buy this module on its own for{" "}
              <strong className="text-white">$49</strong>, no levels required.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
